export default __webpack_public_path__ + "static/media/5w.f25a15cc.svg";